@let model = $surveyCreatorModel();
@if (model) {
  @defer {
    <survey-creator [model]="model" />
  } @loading {
    <span>Loading...</span>
  }
}
